'use client'

import { ColumnDef, createColumnHelper } from '@tanstack/react-table'

import { SpeedOfServiceMetricsModel } from '@/types/clarity'
import {
  DataTableColumnCell,
  DataTableColumnHeader,
  Format,
} from '@/components/ui/data-table'

const columnHelper = createColumnHelper<SpeedOfServiceMetricsModel>()

const groupedColumns = [
  columnHelper.group({
    id: 'adjustedWindowTimeGroup',
    header: () => 'Adjusted Window Time',
    enableHiding: true,
    columns: [
      {
        accessorKey: 'windowEarlyAM',
        header: ({ column }) => {
          return DataTableColumnHeader({ column, title: 'Early AM' })
        },
        cell: ({ row }) => {
          return DataTableColumnCell({
            row,
            accessorKey: 'windowEarlyAM',
            format: Format.NUMBER,
          })
        },
        enableSorting: true,
      },
      {
        accessorKey: 'windowAM',
        header: ({ column }) => {
          return DataTableColumnHeader({ column, title: 'AM' })
        },
        cell: ({ row }) => {
          return DataTableColumnCell({
            row,
            accessorKey: 'windowAM',
            format: Format.NUMBER,
          })
        },
        enableSorting: true,
      },
      {
        accessorKey: 'windowMid',
        header: ({ column }) => {
          return DataTableColumnHeader({ column, title: 'MID' })
        },
        cell: ({ row }) => {
          return DataTableColumnCell({
            row,
            accessorKey: 'windowMid',
            format: Format.NUMBER,
          })
        },
        enableSorting: true,
      },
      {
        accessorKey: 'windowPM',
        header: ({ column }) => {
          return DataTableColumnHeader({ column, title: 'PM' })
        },
        cell: ({ row }) => {
          return DataTableColumnCell({
            row,
            accessorKey: 'windowPM',
            format: Format.NUMBER,
          })
        },
        enableSorting: true,
      },
      {
        accessorKey: 'windowTotal',
        header: ({ column }) => {
          return DataTableColumnHeader({ column, title: 'Total' })
        },
        cell: ({ row }) => {
          return DataTableColumnCell({
            row,
            accessorKey: 'windowTotal',
            format: Format.NUMBER,
          })
        },
        enableSorting: true,
      },
    ],
  }),
  columnHelper.group({
    id: 'windowTimeGroup',
    header: () => 'Window Time',
    enableHiding: true,
    columns: [
      {
        accessorKey: 'windowNonAdjTotal',
        header: ({ column }) => {
          return DataTableColumnHeader({ column, title: 'Non. Adj. Total' })
        },
        cell: ({ row }) => {
          return DataTableColumnCell({
            row,
            accessorKey: 'windowNonAdjTotal',
            format: Format.NUMBER,
          })
        },
        enableSorting: true,
      },
    ],
  }),
  columnHelper.group({
    id: 'adjustedServiceTimeGroup',
    header: () => 'Adjusted Service Time',
    enableHiding: true,
    columns: [
      {
        accessorKey: 'serviceEarlyAM',
        header: ({ column }) => {
          return DataTableColumnHeader({ column, title: 'Early AM' })
        },
        cell: ({ row }) => {
          return DataTableColumnCell({
            row,
            accessorKey: 'serviceEarlyAM',
            format: Format.NUMBER,
          })
        },
        enableSorting: true,
      },
      {
        accessorKey: 'serviceAM',
        header: ({ column }) => {
          return DataTableColumnHeader({ column, title: 'AM' })
        },
        cell: ({ row }) => {
          return DataTableColumnCell({
            row,
            accessorKey: 'serviceAM',
            format: Format.NUMBER,
          })
        },
        enableSorting: true,
      },
      {
        accessorKey: 'serviceMid',
        header: ({ column }) => {
          return DataTableColumnHeader({ column, title: 'MID' })
        },
        cell: ({ row }) => {
          return DataTableColumnCell({
            row,
            accessorKey: 'serviceMid',
            format: Format.NUMBER,
          })
        },
        enableSorting: true,
      },
      {
        accessorKey: 'servicePM',
        header: ({ column }) => {
          return DataTableColumnHeader({ column, title: 'PM' })
        },
        cell: ({ row }) => {
          return DataTableColumnCell({
            row,
            accessorKey: 'servicePM',
            format: Format.NUMBER,
          })
        },
        enableSorting: true,
      },
      {
        accessorKey: 'serviceTotal',
        header: ({ column }) => {
          return DataTableColumnHeader({ column, title: 'Total' })
        },
        cell: ({ row }) => {
          return DataTableColumnCell({
            row,
            accessorKey: 'serviceTotal',
            format: Format.NUMBER,
          })
        },
        enableSorting: true,
      },
    ],
  }),
  columnHelper.group({
    id: 'serviceTimeGroup',
    header: () => 'Service Time',
    enableHiding: true,
    columns: [
      {
        accessorKey: 'serviceNonAdjTotal',
        header: ({ column }) => {
          return DataTableColumnHeader({ column, title: 'Non. Adj. Total' })
        },
        cell: ({ row }) => {
          return DataTableColumnCell({
            row,
            accessorKey: 'serviceNonAdjTotal',
            format: Format.NUMBER,
          })
        },
        enableSorting: true,
      },
    ],
  }),
]

export const groupedSpeedOfServiceColumns: ColumnDef<SpeedOfServiceMetricsModel>[] =
  [
    {
      accessorKey: 'stand',
      header: 'Stand',
      cell: ({ row }) => {
        return DataTableColumnCell({
          row,
          accessorKey: 'stand',
        })
      },
      enableHiding: false,
    },
    ...groupedColumns,
  ]
